import React from 'react';
import { Minus, Plus } from 'lucide-react';
import './QuantitySelector.css';

const MIN = 1;
const MAX = 10;

export default function QuantitySelector({ quantity, onChange }) {
  const clamp = (n) => Math.min(MAX, Math.max(MIN, n));

  return (
    <div className="tp-quantity">
      <label className="label-m tp-quantity__label" htmlFor="tp-quantity-input">
        How many travelers?
      </label>
      <div className="tp-quantity__stepper">
        <button
          type="button"
          className="tp-quantity__btn"
          onClick={() => onChange(clamp(quantity - 1))}
          disabled={quantity <= MIN}
          aria-label="Decrease travelers"
        >
          <Minus size={16} strokeWidth={1.5} />
        </button>
        <input
          id="tp-quantity-input"
          className="tp-quantity__input"
          type="number"
          min={MIN}
          max={MAX}
          value={quantity}
          onChange={(e) => onChange(clamp(Number(e.target.value) || MIN))}
        />
        <button
          type="button"
          className="tp-quantity__btn"
          onClick={() => onChange(clamp(quantity + 1))}
          disabled={quantity >= MAX}
          aria-label="Increase travelers"
        >
          <Plus size={16} strokeWidth={1.5} />
        </button>
      </div>
      <p className="body-s tp-quantity__helper">Each bundle covers one traveler.</p>
    </div>
  );
}
